import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"

const application = Application.start()

// Configure Stimulus development experience
application.debug = true
window.Stimulus = application

// Auto-load all controllers from app/frontend/controllers
const controllers = import.meta.glob("../controllers/**/*_controller.js", { eager: true })

console.log("📦 Controllers found:", Object.keys(controllers))

registerControllers(application, controllers)

console.log("✅ Stimulus loaded with Vite")
console.log("📋 Registered controllers:", application.router.modulesByIdentifier)

export { application }
